export default "https://statics.cloudfastin.top/static/v1.27.34.1/store/images/timeout.jpg?6816afba1c75f89a5b84bbd72353b021";